import wixLocation from 'wix-location';

$w.onReady( () => {
wixLocation.to("/category/נשים");
})